<template>
    <div class="defi">
        <div class="placeholder"></div>
        <div class="defi-bg"></div>
        <div class="defi-bg1"></div>
        <div class="defi-content">
            <div>
                <div class="label">{{$t('defi.referrer')}}</div>
                <div class="value">{{leaderaddr}}</div>
                <div class="link-box">
                    <div class="label">{{$t('defi.shareLink')}}：</div>
                    <div class="link">https://valueplus.us/#/...</div>
                    <div class="btn" @click="copyLink()">{{$t('defi.copy')}}</div>
                </div>
            </div>
        </div>
        <div class="defi-title">{{$t('defi.meStaking')}}</div>
        <div class="defi-card">
            <div>
                <div class="defi-card-label"><span>{{$t('defi.level')}}：</span>{{uservip}}</div>
                <div class="defi-card-ipt-label">{{$t('defi.pls')}}</div>
                <div class="defi-card-ipt-value">
                    <Field class="ipt" v-model="value" :placeholder="$t('defi.pls1')" @input="onInput" ref="ipt" @focus="handleInputFocus" />
                    <div class="btn" @click="doPldge()">{{$t('defi.staking')}}</div>
                </div>

                <div class="defi-card-desc">
                    <div class="defi-card-desc-item">
                        <div>
                            <div class="label">{{$t('defi.desc1.label1')}}：</div>
                            <div class="value">{{Number(powerAmount).toFixed(3)}} T</div>
                        </div>
                        <div>
                            <div class="label">{{$t('defi.desc1.label2')}}：</div>
                            <div class="value">{{Number(rewardPower).toFixed(3)}} T</div>
                        </div>
                    </div>

                    <div class="defi-card-desc-item">
                        <div>
                            <div class="label">{{$t('defi.desc2.label1')}}：</div>
                            <div class="value">{{Number(usdtAmount).toFixed(1)}} U</div>
                        </div>
                        <div>
                            <div class="label">{{$t('defi.desc2.label2')}}：</div>
                            <div class="value">{{Number(rewardUSDT).toFixed(1)}} U</div>
                        </div>
                    </div>

                    <div class="defi-card-desc-item">
                        <div>
                            <div class="label">{{$t('defi.desc3.label1')}}：</div>
                            <div class="value">{{Number(Number(powerAmount)+Number(rewardPower)).toFixed(3)}} T</div>
                        </div>
                        <div>
                            <div class="label">{{$t('defi.desc3.label2')}}：</div>
                            <div class="value">{{Number( Number(usdtAmount)+Number(rewardUSDT)).toFixed(1)}} U</div>
                        </div>
                    </div>

                    <div class="defi-card-desc-item">
                        <div>
                            <div class="label">{{$t('defi.desc4.label1')}}：</div>
                            <div class="value">{{Number(yU).toFixed(1)}} U = {{Number(yYUX).toFixed(3)}} YUX</div>
                        </div>
                    </div>

                    <div class="defi-card-desc-item">
                        <div>
                            <div class="label">{{$t('defi.desc4.label2')}}：</div>
                            <div class="value">{{Number(waitU).toFixed(1)}} U = {{Number(waitYUX).toFixed(3)}} YUX</div>
                        </div>
                    </div>
                </div>

                <div class="defi-card-btn" @click="doWDReward()">{{$t('defi.reward')}}</div>
            </div>
        </div>
        <div class="defi-title">{{$t('defi.rewardRecord')}}</div>

        <div class="defi-list" >
            <div v-if="false">
                <div class="defi-list-item" >
                    <img src="../../assets/img/exchange/icon4.png" alt="">
                    <div>
                        <div class="label" >
                            <span>{{$t('defi.list.label1')}}</span>
                            <span>100 YUXE</span>
                        </div>
                        <div class="value" >
                            <span>2025-06-12 06:21:04</span>
                            <span>{{$t('defi.list.success')}}</span>
                        </div>
                    </div>
                </div>

                <div class="defi-list-item" >
                    <img src="../../assets/img/exchange/icon4.png" alt="">
                    <div>
                        <div class="label" >
                            <span>{{$t('defi.list.label1')}}</span>
                            <span>100 YUXE</span>
                        </div>
                        <div class="value" >
                            <span>2025-06-12 06:21:04</span>
                            <span class="error" >{{$t('defi.list.error')}}</span>
                        </div>
                    </div>
                </div>

                <div class="defi-list-item" >
                    <img src="../../assets/img/exchange/icon4.png" alt="">
                    <div>
                        <div class="label" >
                            <span>{{$t('defi.list.label2')}}</span>
                            <span>100 YUXE</span>
                        </div>
                        <div class="value" >
                            <span>2025-06-12 06:21:04</span>
                            <span>{{$t('defi.list.success')}}</span>
                        </div>
                    </div>
                </div>

                <div class="defi-list-item" >
                    <img src="../../assets/img/exchange/icon7.png" alt="">
                    <div>
                        <div class="label" >
                            <span>{{$t('defi.list.label2')}}</span>
                            <span>100 YUXE</span>
                        </div>
                        <div class="value" >
                            <span>2025-06-12 06:21:04</span>
                            <span>{{$t('defi.list.success')}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Popup v-model="referenceShow" class="referencePopup" get-container="#app" position="center">
            <div class="referencePopup-header">
                <img @click="referenceShow = false" class="close" src="../../assets/img/defi/close1.png" alt="">
            </div>
            <div class="referencePopup-content">
                {{this.linkshareaddr}}
            </div>
            <div class="referencePopup-btn" @click="bindUser()">
                {{ $t('defi.pop.btn') }}
            </div>
        </Popup>
    </div>
</template>

<script>
import { Field, Swipe, SwipeItem, Circle, Tab, Tabs, Popup, Progress, Button } from "vant";
import { copyToClipboard } from "@/utils";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";

import axios from 'axios'
import Web3 from 'web3'
import contractaa from '../contract/index.js'
let web3
web3 = new Web3(window.ethereum)


export default {
    name: "defi",
    components: {
        SplitText,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            value: "",
            referenceShow: false,
            leaderaddr:"0x0000000000000000000000000000000000000000",
            linkshareaddr:"0x0000000000000000000000000000000000000000",
            uservip:'普通',
            powerAmount:0,
            rewardPower:0,
            usdtAmount:0,
            rewardUSDT:0,
            yU:0,
            yYUX:0,
            waitU:0,
            waitYUX:0
        };
    },
    methods: {
        onInput(val) {
            // 只允许数字和小数点
            val = val.replace(/[^\d.]/g, '')

            // 只保留第一个小数点
            const firstDot = val.indexOf('.')
            if (firstDot !== -1) {
                const before = val.slice(0, firstDot + 1)
                const after = val.slice(firstDot + 1).replace(/\./g, '')
                val = before + after
            }

            this.value = val
            return val
        },
         handleInputFocus() {
            const inputDom = this.$refs.ipt.$el;
            if (!inputDom) return;

            setTimeout(() => {
                inputDom.scrollIntoView({
                    behavior: 'instant',
                    block: 'center',
                    inline: 'nearest'
                });

                const rect = inputDom.getBoundingClientRect();
                const scrollTop = window.scrollY + rect.top - 100;
                window.scrollTo({
                    top: scrollTop,
                    left: 0,
                    behavior: 'instant'
                });
            }, 300);
        },
        getVIPName(vip){
            let name="";
            switch(vip){
                case 0:name="普通";break;
                case 1:name="白银";break;
                case 2:name="翡翠";break;
                case 3:name="黄金";break;
                case 4:name="铂金";break;
                case 5:name="钻石";break;
            }
            return name;
        },
        async isAltBindUser(){
            let that = this;
            let address = this.$store.state.globalAddress;
            let DefiContract = new web3.eth.Contract(contractaa.abiDefi,contractaa.DefiToken);
            await DefiContract.methods.userList(address).call({from:address}).then(function(result){
                that.leaderaddr = result[0]

                let _shareaddr = that.$route.query.share
              
                if(_shareaddr!="" && _shareaddr!=undefined && that.leaderaddr == "0x0000000000000000000000000000000000000000"){
                    that.referenceShow = true
                    that.linkshareaddr = _shareaddr
                    that.$store.state.shareaddr = _shareaddr;
                    
                }

            })
        },
        async getInfo(){
            let that = this;
            let address = this.$store.state.globalAddress;

            let DefiContract = new web3.eth.Contract(contractaa.abiDefi,contractaa.DefiToken);
            await DefiContract.methods.userList(address).call({from:address}).then(function(result){
                that.leaderaddr = result[0]
                
                that.uservip = that.getVIPName(Number(result[1]))
               
                let _shareaddr = that.$route.query.share
              
                if(_shareaddr!="" && _shareaddr!=undefined && that.leaderaddr == "0x0000000000000000000000000000000000000000"){
                    //that.referenceShow = true
                    that.linkshareaddr = _shareaddr
                    that.$store.state.shareaddr = _shareaddr;
                    
                }
                that.powerAmount = web3.utils.fromWei(result[2],'ether');
                that.rewardPower = web3.utils.fromWei(result[5],'ether');
                that.usdtAmount = web3.utils.fromWei(result[4],'ether');
                that.rewardUSDT = web3.utils.fromWei(result[6],'ether');
                that.yU = web3.utils.fromWei(result[9],'ether');
                that.yYUX = web3.utils.fromWei(result[8],'ether');
            })
            await DefiContract.methods.getPendingU(address).call({from:address}).then(function(result){
                that.waitU = web3.utils.fromWei(result[0],'ether');
            })
            let _usdt = that.waitU
            await DefiContract.methods.getYuxByU(web3.utils.toWei(_usdt,'ether')).call({from:address}).then(function(result){
                that.waitYUX = web3.utils.fromWei(result,'ether');
            })



        },
        //领取奖励
        doWDReward(){
            let that = this;
            let address = this.$store.state.globalAddress;

            let DefiContract = new web3.eth.Contract(contractaa.abiDefi,contractaa.DefiToken);
            DefiContract.methods.wdReward().send({from:address}).then(receipt => {
                //监听后续的交易情况
                if (receipt.status == "1") {
                    // axios.get(contractaa.APIURL+'?cmd=addexchange&tx='+receipt.transactionHash).then(function (response) {
                    // if (response.status === 200) {
                    //         console.log("axios:"+response.data.Message)
                    //     }
                    // })
                    //that.$toast.success(that.$t('node.success'));
                    that.$store.commit('handleLoading', false)
                    that.getInfo();
                    

                } else {
                    that.$toast.fail(that.$t('node.error'));
                }          
            });
        },
        //质押
        doPldge(){
            let that = this;
            let address = this.$store.state.globalAddress;

            let DefiContract = new web3.eth.Contract(contractaa.abiDefi,contractaa.DefiToken);
            let YUXEContract = new web3.eth.Contract(contractaa.abiUsdt,contractaa.YUXEToken);
            let _amount = that.value
           
            let maxmunber = '115792089237316195423570985008687907853269984665640564039457584007913129639935';
            that.$store.commit('handleShow', true)
            YUXEContract.methods.allowance(address,contractaa.DefiToken).call({from:address}).then(function(result){
                //获取 result 授权数量
                let dd = web3.utils.fromWei(result,'ether')
                console.log('授权数量'+dd);
                if(dd >= _amount){
                    DefiContract.methods.doPledge(web3.utils.toWei(_amount,'ether')).send({from:address}).then(receipt => {
                        //监听后续的交易情况
                        if (receipt.status == "1") {
                            // axios.get(contractaa.APIURL+'?cmd=addexchange&tx='+receipt.transactionHash).then(function (response) {
                            // if (response.status === 200) {
                            //         console.log("axios:"+response.data.Message)
                            //     }
                            // })
                            //that.$toast.success(that.$t('node.success'));
                            that.$store.commit('handleLoading', false)
                            that.getInfo();

                        } else {
                            that.$toast.fail(that.$t('node.error'));
                        }          
                    });
                }else{
                    YUXEContract.methods.approve(contractaa.DefiToken,maxmunber).send({from:address}).then(receipt => {
                        //监听后续的交易情况
                        if (receipt.status == "1") {
                            DefiContract.methods.doPledge(web3.utils.toWei(_amount,'ether')).send({from:address}).then(receipt => {
                                    //监听后续的交易情况
                                    if (receipt.status == "1") {
                                        // axios.get(contractaa.APIURL+'?cmd=addexchange&tx='+receipt.transactionHash).then(function (response) {
                                        // if (response.status === 200) {
                                        //         console.log("axios:"+response.data.Message)
                                        //     }
                                        // })
                                        //that.$toast.success(that.$t('node.success'));
                                        that.$store.commit('handleLoading', false)
                                        that.getInfo();
                                       
                                    } else {
                                        that.$toast.fail(that.$t('node.error'));
                                    }          
                                });

                        } else {
                           that.$toast.fail(that.$t('node.error'));
                        }          
                    });
                }
            })
        },
        //绑定关系
        bindUser(){
            let that = this;
            let address = this.$store.state.globalAddress;
            let leader = that.linkshareaddr;
            let DefiContract = new web3.eth.Contract(contractaa.abiDefi,contractaa.DefiToken);
            DefiContract.methods.bindUser(leader).send({from:address}).then(receipt => {
                //监听后续的交易情况
                if (receipt.status == "1") {
                    that.$toast.success(this.$t('node.success'));
                    that.getInfo();
                    that.referenceShow = false

                } else {
                    that.$toast.fail(that.$t('node.error'));
                }          
            });
        },
        copyLink(){
            var link="http://testdefi.valueplus.us/#/defi?share="+this.$store.state.globalAddress;
            copyToClipboard(link)
            this.$toast.success(this.$t('node.success'));
        }
    },
    mounted() {
        setTimeout(() => {
            this.isAltBindUser()
            this.getInfo()
        }, 200)
    },

    computed: {

    },
};
</script>

<style lang="less" scoped>
.defi {
    position: relative;
    background-size: 100% 800px;
    padding: 0 16px 42px;
    background: url("../../assets/img/home/header-bg.png") no-repeat;
    background-size: 471.9px 240.62px;
    background-position: -60px -97px;

    &-bg {
        width: 375px;
        position: absolute;
        height: 178px;
        top: -44px;
        background: url("../../assets/img/layout/bg.png") no-repeat center;
        background-size: 100% 100%;
    }

    .placeholder {
        height: 50px;
    }

    .px15 {
        padding: 0 15px;
    }
    .defi-bg1 {
        margin-top: 8px;
        height: 7px;
        position: relative;
        z-index: 23;
        width: 100%;
        background: #020307;
    }
    .defi-content {
        position: relative;
        z-index: 23;
        min-height: 120px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-bottom: 20px;

        background: url('../../assets/img/defi/bg.png') no-repeat;
        background-size: 100% 100%;
        > div {
            width: 100%;
            height: 100%;
            padding: 15px;
            border-radius: 10px;
            .label {
                font-size: 13px;
                color: #a1a0a3;
                line-height: 18px;
                margin-bottom: 5px;
            }
            .value {
                margin-bottom: 11px;
                line-height: 18px;
                color: #ffffff;
                font-size: 13px;
            }
            .link-box {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 38px;
                border-radius: 10px;
                background: #000000;
                .label {
                    font-size: 12px;
                    color: #999999;
                    line-height: 17px;
                }
                .link {
                    font-size: 12px;
                    line-height: 17px;
                    color: #ffffff;
                }
                .btn {
                    margin-left: 25px;
                    line-height: 17px;
                    color: #161617;
                    font-size: 12px;
                    min-width: 64px;
                    height: 28px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 8px;
                    background: linear-gradient(112deg, #0df1d5 0%, #0190d1 97%);
                }
            }
        }
    }
    &-title {
        color: #ffffff;
        font-size: 16px;
        line-height: 22px;
        font-weight: 500;
        margin-bottom: 10px;
    }
    .defi-card {
        min-height: 352px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-bottom: 20px;
        background: url('../../assets/img/defi/bg1.png') no-repeat;
        background-size: 100% 100%;
        > div {
            width: 100%;
            height: 100%;
            padding: 15px;
            border-radius: 10px;
            .defi-card-label {
                font-size: 12px;
                line-height: 17px;
                margin-bottom: 20px;
                color: #ffffff;
                span {
                    color: #a1a0a3;
                }
            }
            .defi-card-ipt-label {
                font-size: 12px;
                line-height: 17px;
                margin-bottom: 10px;
                color: #ffffff;
            }
            .defi-card-ipt-value {
                display: flex;

                .btn {
                    margin-left: 10px;
                    height: 38px;
                    line-height: 17px;
                    color: #000000;
                    font-size: 13px;
                    min-width: 80px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 8px;
                    background: linear-gradient(112deg, #0df1d5 0%, #0190d1 97%);
                }
            }
            .defi-card-desc {
                margin-top: 20px;
                > div {
                    display: flex;
                    margin-top: 10px;
                    > div {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        line-height: 17px;
                        .label {
                            color: #a1a0a3;
                        }
                        .value {
                            color: #fff;
                        }
                    }
                }
            }
            .defi-card-btn {
                margin-top: 20px;
                line-height: 17px;
                color: #000000;
                font-size: 14px;
                font-weight: 500;
                height: 56px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 12px;
                background: linear-gradient(112deg, #0df1d5 0%, #0190d1 97%);
            }
        }
    }

    .defi-list {
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-bottom: 20px;
        overflow: hidden;
        background: url('../../assets/img/defi/list-bg.png') no-repeat;
        background-size: 100% 100%;
        > div {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            .defi-list-item {
                display: flex;
                align-items: center;
                padding: 14px 15px 13px;
                > img {
                    width: 34px;
                    height: 34px;
                    margin-right: 8px;
                }
                > div {
                    flex: 1;
                    .label {
                        display: flex;
                        justify-content: space-between;
                        font-size: 14px;
                        line-height: 20px;
                        color: #ffffff;
                        margin-bottom: 6px;
                    }
                    .value {
                        display: flex;
                        justify-content: space-between;
                        font-size: 12px;
                        line-height: 17px;
                        color: #7E7D87;
                    }
                    .error {
                        color: #BD4253;
                    }
                }
            }
        }
    }
}
</style>
<style lang="less">
.defi-card-ipt-value {
    .ipt {
        flex: 1;
        height: 38px;
        padding: 0 15px !important;
        border: 1px solid #4f4e53;
        background: #000000;
        border-radius: 10px;
        padding: 0;
        background-color: transparent;
        display: flex;
        align-items: center;
        &::after {
            display: none !important;
        }
        input {
            font-size: 14px;
            line-height: 20px;
            color: #999999;

            &::placeholder {
                color: #999999;
            }
        }
    }
}

.referencePopup {
    width: 305px;
    min-height: 172px;
    background: url('../../assets/img/defi/pop-bg.png') 100% no-repeat;
    background-size: 100% 100%;
    border-radius: 12px;
    padding: 0 15px 0;

    .referencePopup-header {
        text-align: center;
        color: #E8E8E8;
        font-size: 16px;
        padding-top: 14px;
        position: relative;
        margin-bottom: 25px;
        height: 24px;
        .close {
            position: absolute;
            right: -5px;
            top: 10px;
            width: 26px;
            height: 26px;
        }
    }

    .referencePopup-content {
        color: #FFFFFF;
        font-size: 12px;
        text-align: center;
        margin-bottom: 24px;
        word-break: break-all;
        padding: 0 20px;
    }

    .referencePopup-btn {
        margin-top: 20px;
                line-height: 17px;
                color: #000000;
                font-size: 14px;
                font-weight: 500;
                height: 48px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 12px;
                background: linear-gradient(112deg, #0df1d5 0%, #0190d1 97%);
    }
}
</style>
